'use client';

import { forwardRef } from 'react';
import { Textarea as MantineTextArea } from '@mantine/core';
import type { TextareaProps as MantineTextareaProps } from '@mantine/core';

import type { LockedProps } from '../types';

export type TextAreaProps = Omit<MantineTextareaProps, LockedProps>;

/**
 * ### TextArea
 *
 * @description
 * Mantine's Textarea minus per-call-site style overrides (see {@link LockedProps}),
 * with a locked label/input/error/description order. For a monospace input use the
 * `MonospaceTextArea` composition from `@highlight-cp/core-ui-compositions`.
 *
 * @example
 * <TextArea label="Notes" placeholder="Optional details" />
 *
 * @param props - {@link TextAreaProps}
 * @returns React component
 */
export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>((props, ref) => (
  <MantineTextArea
    ref={ref}
    inputWrapperOrder={['label', 'input', 'error', 'description']}
    {...props}
  />
));

TextArea.displayName = 'TextArea';
